import React from 'react';
import Lottie from 'lottie-react';
import LiveIcon from '../../molecules/card-image-headline/lottie-live-icon.json';
import Icon from '@mdi/react';
import { mdiTelevisionClassic,mdiChevronRight} from '@mdi/js';
import { BQLink } from '../../atoms/bqlink';
import './expand-videos-widget.m.css';


const ExpandVideosWidget = ({ story, datalayerFields, mostRead, isLiveBlog }) => {
  return (
    <div styleName="expandVideosWidget">
      <div styleName="live-icon">
        <Lottie animationData={LiveIcon} loop={true} autoplay={true} />
      </div>
      <div styleName="first-row">
        <div styleName="first-row-child1">
          <img src="/images/NDTV-Profit-logo-darkmode.png" alt="ndtv|Profit" width='120px'/>
          <div styleName="static-text">24/7 LIVE Stream</div>
        </div>
       <div styleName="sv-bottom">
        <BQLink href={`/videos?src=must_watch`} styleName="sv-bottom-text">
          <Icon path={mdiTelevisionClassic} size='20px' color="#d01e51" />
          <span styleName="sv-bottom-title">WATCH</span>
          <Icon path={mdiChevronRight} size='20px' color="#d01e51" />
        </BQLink>
      </div>
      </div>
    </div>
  );
};

export default ExpandVideosWidget;
